import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./index.module.scss";
import { forwardRef } from "react";
export const NewBaseIcon = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    icon,
    size = 16,
    color,
    style,
    className,
    ...restProps
  } = props;
  const computedStyle = {
    width: size,
    height: size,
    color: color,
    ...style
  };
  return typeof icon === "string" ? /*#__PURE__*/_jsx("div", {
    style: computedStyle,
    ref: ref,
    className: classNames([styles.icon_style], [className]),
    dangerouslySetInnerHTML: {
      __html: icon
    },
    ...restProps
  }) : icon;
});